<template>
    <div class="modeling-list table-responsive">
        <table class="table table-bordered table-responsive-md">
            <thead>
                <tr>
                    <th class="text-center">{{ $t('modelings') }}
                        <RouterLink style="float: right" :to="{ name: 'modelingadd'}"><i class="fas fa-lg fa-plus"></i></RouterLink>
                    </th>
                </tr>
            </thead>
            <tbody v-if="listOfModelings.length > 0">
                <tr>
                    <input style="border:none" class="form-control" :placeholder="$t('modelingName')" v-model="filterInput" type="search">
                </tr>
                <tr v-for="(item, i) in listOfModelings" :key="i">
                    <td>
                        <RouterLink :to="{ name: 'settingsmodelingdetail', params: { id: item.id } }">
                            {{ item.name }}
                        </RouterLink>
                        <i style="float:right; padding-top:10px; cursor: pointer" @click="showDeleteModelingModal(item)" class="fas fa-sm fa-trash"></i>
                    </td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr>
                    <input class="form-control" :placeholder="$t('filterByName')" v-model="filterInput" type="search">
                </tr>
                <tr>
                    {{ $t('noAssignedModeling') }}
                </tr>
            </tbody>
        </table>
        <ModelingDeleteModal v-if="isModalVisible" @reload="requestData"></ModelingDeleteModal>
    </div>
</template>

<script>
import ModelingApi from "../../../api/server/modeling";
import ModelingDeleteModal from "./ModelingDeleteModal";

export default {
    name: "ModelingList",
    components: {
        ModelingDeleteModal
    },
    mounted() {
        this.requestData();
    },
    computed: {
        listOfModelings(){
            if (!this.filterInput){
                return this.modelingList.sort((a, b) => a.name.localeCompare(b.name));
            } else {
                const lowerCaseFilter = this.filterInput.toLowerCase();

                return this.modelingList.sort((a, b) => a.name.localeCompare(b.name)).filter((modeling) => { 
                    if(modeling.name.toLowerCase().includes(lowerCaseFilter))
                    return modeling;
                });
            }
        }
    },
    methods: {
        async requestData() {
            this.modelingList = await ModelingApi.modelingList();
        },
        showDeleteModelingModal(item) {
            this.modelingToDeleteId = item.id
            this.modelingToDeleteName = item.name
            this.isModalVisible = true
        }
    },
    data() {
        return {
            modelingList: [],
            modelingToDeleteName: "",
            modelingToDeleteId: "",
            isModalVisible: false,
            filterInput: ""
        }
    }
};
</script>